export enum InteractionType {
  SHOW_MORE_RECOMMENDATIONS = "show_more",
  SHOW_POPULAR_RECOMMENDATIONS = "show_popular",
  NOT_SATISFIED = "not_satisfied"
}

export const INTERACTION_TYPE_LABELS = {
  [InteractionType.SHOW_MORE_RECOMMENDATIONS]: "chatbot.showMoreRecommendations",
  [InteractionType.SHOW_POPULAR_RECOMMENDATIONS]: "chatbot.showPopularRecommendations",
  [InteractionType.NOT_SATISFIED]: "chatbot.notSatisfied",
}
